export default __webpack_public_path__ + "static/media/copy_icon.c273e184.svg";